import { footerCols } from "../../../mocks/clueSite";

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300/70 text-foreground-700">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center gap-2.5 whitespace-nowrap">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded bg-primary-600 text-background-50">
                <i className="ri-error-warning-fill text-lg" />
              </span>
              <span className="leading-none">
                <span className="block font-heading text-xl font-black text-foreground-950">
                  51<span className="text-primary-600">黑料</span>
                </span>
                <span className="block mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">
                  线 索 · 密 报 · 线 人
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              51黑料是一家线索征集与汇总站，长期接受投稿与密报，汇总线人爆料并交叉核验。提供独家线索或内部消息，点上方入口即可匿名提交。
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap">
              {["安全投稿", "密报加密", "线人保护"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-50 px-3 py-1 text-xs text-foreground-600 border border-background-300/60"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerCols.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <p className="text-sm font-semibold text-foreground-900">{col.title}</p>
              <ul className="mt-3 space-y-2">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 hover:text-primary-700 whitespace-nowrap"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1 md:flex md:flex-col md:items-end">
            <a
              href="#guide"
              className="inline-flex w-full md:w-auto items-center justify-center gap-1.5 rounded-full bg-primary-600 px-4 py-2 text-sm text-background-50 hover:bg-primary-500 whitespace-nowrap"
            >
              <i className="ri-upload-2-line" />
              投稿爆料
            </a>
            <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-mail-line" />
              tip@51heiliao.site
            </p>
          </div>
        </div>

        <div className="mt-10 hairline" />

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-foreground-500">
          <p>
            © 2026 51黑料官网 · 线索征集与爆料汇总平台。本站素材来自用户投稿并经脱敏处理，内容与结论仅供参考，请理性看待。
          </p>
          <p className="whitespace-nowrap">投稿 · 爆料 · 密报 · 线人 一站式入口</p>
        </div>
      </div>
    </footer>
  );
}